import './styles.sass'

import React, { FC, useEffect, useState } from 'react'
import { CircleIcon, TickCircleIcon, ArrowDown } from '../../../assets/icons'

interface IFormSelect {
  list: IListItem[],
  label?: string,
  defaultValue: string,
  onChange: (item: IListItem) => void,
  disabled?: boolean,
}

interface IListItem {
  value: string,
  label: string,
  default?: boolean,
  disabled?: boolean,
}

const FormSelect: FC<IFormSelect> = ({ list, label, defaultValue, onChange, disabled }) => {
  const [selected, setSelected] = useState<IListItem>({} as IListItem)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const defaultSelect = list.find((item) => item.value === defaultValue);

    if (defaultSelect) {
      setSelected(defaultSelect);
      onChange(defaultSelect);
    }
  }, [list]);

  const handleSelect = (item: IListItem) => {
    setSelected(item)
    setOpen(false)
    onChange(item)
  }

  return (
    <div className='form-select'>
      <div className="label">{label}</div>
      <div className={`input-container ${open ? 'open' : 'closed'}`} onClick={() => !disabled ? setOpen(!open) : {}}>
        <div className="selected-option">{selected.label || 'Select'}</div>
        <span className="icon">
          <ArrowDown color={open ? "#574BC9" : "#73777F"} />
        </span>
      </div>
      <ul className={`options ${open ? 'open' : 'closed'}`}>
        {list.map(item => (
          <li className="option" onClick={() => handleSelect(item)} key={`${item.value}`}>
            <span className="indicator">
              {selected.value === item.value ?
                <TickCircleIcon color={'#574BC9'} />
                : <CircleIcon color='#73777F' />}
            </span>
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default FormSelect